import { ALPHABET, BASE_GLOSSARY_PATH } from '../constants';
import type { ReducedLettersType } from '../types';

import { Styled } from './glossary.styles';

export type GlossaryType = {
  reducedLetters?: ReducedLettersType;
  openInSameTab?: boolean;
};

export const Glossary: React.FC<GlossaryType> = ({
  reducedLetters,
  openInSameTab = false,
}) => (
  <Styled.List variant="row">
    {ALPHABET.split('').map((letter) => (
      <Styled.ListItem key={letter}>
        <Styled.Link
          data-qa={`career-hub-glossary-options-${letter}`}
          href={
            !reducedLetters || reducedLetters?.[letter]
              ? `${BASE_GLOSSARY_PATH}#${letter}`
              : ''
          }
          {...(!openInSameTab && { target: '_blank' })}
        >
          {letter}
        </Styled.Link>
      </Styled.ListItem>
    ))}
  </Styled.List>
);
